import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import LoginPage from '../views/LoginPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: LoginPage, name: 'LoginPage' },
  { path: '/home', component: HomePage, name: 'HomePage' },
  {
    path: '/factory',
    name: 'factory',
    component: () => import(/* webpackChunkName: "factory" */ '@/views/factory/index.vue')
  },
  {
    path: '/device',
    name: 'device',
    component: () => import(/* webpackChunkName: "device" */ '@/views/device/index.vue')
  },
  {
    path: '/security',
    name: 'security',
    component: () => import(/* webpackChunkName: "security" */ '@/views/security/index.vue')
  },
  {
    path: '/alert',
    name: 'alert',
    component: () => import(/* webpackChunkName: "alert" */ '@/views/alert/index.vue')
  },
  {
    path: '/data-center',
    name: 'data_center',
    component: () => import(/* webpackChunkName: "data-center" */ '@/views/data-center/index.vue')
  },
  {
    path: '/monitor',
    name: 'monitor',
    component: () => import(/* webpackChunkName: "monitor" */ '@/views/monitor/index.vue')
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import(/* webpackChunkName: "mine" */ '@/views/mine/index.vue')
  },
  {
    path: '/asset',
    name: 'asset',
    component: () => import(/* webpackChunkName: "asset" */ '@/views/asset/index.vue')
  },
  {
    path: '/track',
    name: 'track',
    component: () => import(/* webpackChunkName: "track" */ '@/views/track/index.vue')
  },
  {
    path: '/behavior',
    name: 'behavior',
    component: () => import(/* webpackChunkName: "behavior" */ '@/views/behavior/index.vue')
  },
  {
    path: '/audit',
    name: 'audit',
    component: () => import(/* webpackChunkName: "audit" */ '@/views/audit/index.vue')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import(/* webpackChunkName: "message" */ '@/views/message/index.vue')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import(/* webpackChunkName: "report" */ '@/views/report/index.vue')
  },
  {
    path: '/workorder',
    name: 'workorder',
    component: () => import(/* webpackChunkName: "workorder" */ '@/views/workorder/index.vue')
  },

  // 系统管理（原 cxc 超管 RBAC 页：管理员管理/菜单/权限/角色/标签/分组）
  // 这些页面列出全量 tb_users，属于跨公司超管视角，Sentinel 单主账号/公司模型下不适用，
  // 已从后端 WebMenu 与前端菜单中移除，故不再注册路由。
]

const router = new VueRouter({
  routes
})

export default router
